
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user-agreement",
      function () {
        return require("private-next-pages/user-agreement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user-agreement"])
      });
    }
  